import {
    addToSelection,
    clearSelection,
    removeFromSelection,
} from '../reducers';

import {selectionSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {useDomainNamesQuery} from './useDomainNamesQuery';
import {DomainName} from '../types';


// FNP-951 + FNP-942: selection stays in Redux (correct), but the `items` that
// select-all iterates now come from React Query rather than the records slice.
export const useDomainNamesSelection = () => {
    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));

    const {data} = useDomainNamesQuery();

    // FNP-1282: the query is now an infinite query, so select-all iterates the
    // pages loaded SO FAR — which is the only set the checkboxes can refer to.
    const items: DomainName[] = (data?.pages ?? [])
        .flatMap(page => (page && 'items' in page) ? (page.items ?? []) : [])
        .filter(Boolean);


    // SELECTION
    const handleRowSelection = (row: { id: string }) => {
        if (typeof selection[row.id] !== 'undefined') {
            dispatch(removeFromSelection(row.id));
        } else {
            dispatch(addToSelection(row));
        }
    };

    const handleSelectAllRows = () => {
        for (let i = 0; i < items.length; i++) {
            if (typeof selection[items[i].id] !== 'undefined') {
                dispatch(removeFromSelection(items[i].id));
            } else {
                dispatch(addToSelection(items[i]));
            }
        }
    };

    const handleClearSelection = () => {
        dispatch(clearSelection());
    };

    return {
        items,
        selection,
        handleRowSelection,
        handleSelectAllRows,
        handleClearSelection,
    };
};
